import React from 'react';
import { Input, Row, Col } from 'antd';

import { FormItem } from 'utils';
import { ImageUpload } from 'components/common';


const MainFieldSet = (props) => {
  const editObject = props.brand.editObject || {};

  return (
    <Row gutter={32}>
      <Col span={16}>
        <div className="form-block">
          <FormItem {...props} name="name" label="Название" required={true}>
            <Input size="large" />
          </FormItem>

          <FormItem {...props} name="slug" label="Код" required={true}>
            <Input size="large" />
          </FormItem>
        </div>
      </Col>

      <Col span={8}>
        <div className="form-block">
          <FormItem {...props} name="logo" required={false} valuePropName="fileList">
            <ImageUpload 
              title="Загрузить логотип"
              mode='single'
              auth_token={props.auth_token}
              siteDomain={props.site.activeDomain}
              modelName="catalog.brand"
              data={{ext_id: editObject.ext_id}}
            />
          </FormItem>
        </div>
      </Col>
    </Row>
  );
};

export default MainFieldSet;
